import { useAppDispatch, useAppSelector } from 'app/store';
import { useEffect } from 'react';
import { onBoardingPresentationCompleted, selectUserInfo } from 'app/store/user';

import './style.scss';

import { Typography } from 'components/ui/typography';
import { ApiKeySection } from './components/ApiKeySection';
import { QuickStartSection } from './components/QuickStartSection';
import { ExploreSection } from './components/ExploreSection';

const Page = () => {
  const dispatch = useAppDispatch();
  const userInfo = useAppSelector(selectUserInfo);
  const playAnimation = userInfo?.onBoardingPresentationComplete;

  useEffect(() => {
    if (typeof userInfo?.onBoardingPresentationComplete !== 'undefined') {
      setTimeout(() => dispatch(onBoardingPresentationCompleted()), 1500);
    }
  }, [dispatch, userInfo?.onBoardingPresentationComplete]);

  return (
    <div
      className={
        typeof playAnimation !== 'undefined' && !playAnimation
          ? 'dashboard dashboard-greeting'
          : 'dashboard'
      }
    >
      <div className="mx-auto max-w-5xl space-y-4 px-3 py-6 sm:space-y-6 sm:px-4 sm:py-8">
        <div className="mb-6 sm:mb-8">
          <Typography variant="h2" as="h1" className="mb-2">
            Complete your first Checkout Intent
          </Typography>
          <Typography variant="lede" as="p">
            Follow the steps below to get started using Rye's universal checkout API.
          </Typography>
        </div>
        <ApiKeySection />
        <QuickStartSection />
        <ExploreSection />
      </div>
    </div>
  );
};

export default Page;
